import { useEffect, useState } from "react";
import { useAdmin, adminAxios } from "./AdminContext";
import { Mail } from "lucide-react";

export default function MessagesAdmin() {
  const { token } = useAdmin();
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    adminAxios(token).get("/admin/messages").then(r => setItems(r.data.items || [])).catch(() => {});
  }, [token]);

  const fmt = (iso) => { try { return new Date(iso).toLocaleString("tr-TR"); } catch { return iso; } };

  return (
    <div className="space-y-6" data-testid="admin-messages">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight flex items-center gap-3"><Mail size={26} /> İletişim Mesajları</h1>
        <p className="text-white/50 mt-2">Sitedeki iletişim formundan gelen tüm mesajlar.</p>
      </div>

      <div className="space-y-3" data-testid="admin-messages-list">
        {items.length === 0 ? (
          <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-10 text-center text-white/50 text-sm">Henüz mesaj yok.</div>
        ) : items.map(m => (
          <article key={m.id} className="rounded-2xl bg-white/[0.03] border border-white/10 overflow-hidden">
            <button onClick={() => setOpenId(openId === m.id ? null : m.id)} className="w-full flex items-start justify-between gap-4 p-5 hover:bg-white/[0.02] text-left">
              <div className="flex-1 min-w-0">
                <div className="font-semibold">{m.name} <span className="text-white/40">— {m.email}</span></div>
                <div className="text-xs text-white/50 mt-1 truncate">{m.subject || "(Konu yok)"} • {fmt(m.created_at)}</div>
              </div>
              <span className="text-white/40 text-xs">{openId === m.id ? "Kapat" : "Aç"}</span>
            </button>
            {openId === m.id && (
              <div className="px-5 pb-5 pt-2 text-sm text-white/80">
                <div className="grid sm:grid-cols-2 gap-2 text-[11px] uppercase tracking-[0.2em] text-white/40 mb-3">
                  <div>Telefon: <span className="text-white/70 normal-case tracking-normal">{m.phone || "-"}</span></div>
                  <div>Konu: <span className="text-white/70 normal-case tracking-normal">{m.subject || "-"}</span></div>
                </div>
                <p className="whitespace-pre-line leading-relaxed">{m.message}</p>
              </div>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}
